import Vue from 'vue'


// initial state
const state = {
  descriptionPKID: '',
  craftConfig: {
    id:'',
    materialCode: '',
  },
  message:{
    type:'',
    text:''
  }
}

// getters
const getters = {}

// actions
const actions = {
  updateObject({ commit }, { obj, attr, val }) {
    commit('UPDATE_OBJECT', { obj, attr, val })
  },
  saveDescriptionPKID({commit, dispatch}, id) {
    dispatch('updateObject', {
      obj: state,
      attr: 'descriptionPKID',
      val: id
    })
  },
  getCraftConfig({ commit, dispatch }, config) {
    dispatch('updateObject', {
      obj: state,
      attr: 'craftConfig',
      val: config
    });
  },
}

// mutations
const mutations = {
  UPDATE_OBJECT(state, { obj, attr, val }) {
    Vue.set(obj, attr, val);
  },
  

}

export default {
  state,
  getters,
  actions,
  mutations
}
